const HOST_ROUTE_PREFIX = '/host/';

/** Screens whose section code differs from the route name. Keys are Next.js route patterns (`router.pathname`). */
const ROUTE_OVERRIDES: Record<string, string> = {
  '/host/livestream-calendar/[id]': 'livestream-calendar#detail',
};

/** The guide is only available on the Host portal screens (login and the other portals are excluded). */
export const isPlaybookRoute = (pathname: string): boolean => pathname.startsWith(HOST_ROUTE_PREFIX);

/**
 * Route pattern -> section code to open. Defaults to the screen name after `/host/`
 * (`/host/overview-report` -> `overview-report`). The code may not exist in the guide; the panel then falls back
 * to the first section.
 */
export const getSectionIdByRoute = (pathname: string): string | undefined => {
  const base = pathname.split('?')[0].replace(/\/+$/, '');
  if (ROUTE_OVERRIDES[base]) return ROUTE_OVERRIDES[base];
  if (!isPlaybookRoute(base)) return undefined;
  return base.slice(HOST_ROUTE_PREFIX.length).split('/')[0] || undefined;
};
